<template>
    <div class="schedule-mat-footer">
        <div class="schedule-mat-footer-stat">
            <p class="is-size-7">{{ translate("admin_schedule_manage.total_fights") }}</p>
            <p class="has-text-weight-bold has-text-white">{{ matScheduleSummary.totalFights }}</p>
        </div>
        <div class="ml-2 schedule-mat-footer-stat">
            <p class="is-size-7">{{ translate("admin_schedule_manage.total_time_on_single_mat") }}:</p>
            <p class="has-text-weight-bold has-text-white">{{ formattedTotalTime }}</p>
        </div>
        <div class="ml-2 schedule-mat-footer-stat">
            <p class="is-size-7">{{ translate("admin_schedule_manage.eta_of_single_mat") }}</p>
            <p class="has-text-weight-bold has-text-white">{{ formattedEta }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../../Common/translations";
    import { convertToTimezone } from "../../Common/dateTimeUtils";
    import timeFormatter from "../../Common/timeFormatter";
    import { useScheduleMainStore } from "./useScheduleMainStore";
    import type { MatScheduleSummary } from "../../Api/schedules";

    const props = defineProps<{
        matScheduleSummary: MatScheduleSummary;
    }>();

    const mainStore = useScheduleMainStore();

    const formattedEta = computed(() => {
        if (!props.matScheduleSummary.eta) {
            return "--:--";
        }

        const eta = convertToTimezone(props.matScheduleSummary.eta, mainStore.eventTimezone, "HH:mm");

        if (eta === "") {
            return "--:--";
        } else {
            return eta;
        }
    });

    const formattedTotalTime = computed(() => {
        return timeFormatter.formatSecondsToMinutesAndSeconds(props.matScheduleSummary.totalTime, "compact");
    });
</script>

<style scoped>
    .ml-2 {
        margin-left: 0.5rem;
    }
</style>
